import { createHttpRequest } from '../utils/services'

export const appService = {
	/**
	 * getSettings get settings for the app
	 *
	 * @param {string} place
	 * @param {string} pageId
	 * @return {*}
	 */
	async getSettings (place:string, pageId:string) {
		const res = await createHttpRequest(`places/${place}?pageId=${pageId}`, { method: 'GET' })
		if (!res.error) {
			return res.data
		} else {
			return res.error
		}
	},
	// `getGLobalSettings` (`GET settings`) a disparu le 08/10 avec les CGU
	// globales : les CGU sont celles de chaque jeu, dans son formulaire.
	// `getArea` (`GET areas/:id`) a disparu : route d'administration, elle
	// répondait 401 à un spectateur. La zone scannée arrive avec le lieu
	// (`currentArea`, dans `getSettings`).
}
